import { findKey, xor, reduce, isEmpty, isNil } from 'lodash-es';
import { differenceInDays, endOfMonth, subDays, yesterday } from '../../../utils/date';

export const getRegionName = (selectedCountries) => {
  if (isEmpty(selectedCountries)) return {};
  let nextSelected = [...selectedCountries];

  const allSelectedRegions = reduce(
    TINKERBELL_REGIONS,
    (result, { list, value }) => {
      if (new Set([...nextSelected, ...list]).size === nextSelected.length) {
        nextSelected = xor(nextSelected, list);
        return [...result, value === 'worldwide' ? 'Worldwide' : value]; // add list if needed;
      }

      return result;
    },
    []
  );

  return {
    selectedRegions: allSelectedRegions,
    remainingCountries: nextSelected,
  };
};

export const getEntityTypeByUids = (uids, defaultType = 'company') => {
  if (!uids.length) return defaultType;

  const entityTypes = {
    app: ['UA:', 'A:'],
    publisher: ['UP:', 'P:'],
    company: ['UC:'],
  };

  const checkEntityType = (types) =>
    uids.every((uid) => types.some((type) => uid.startsWith(type)));

  return findKey(entityTypes, (types) => checkEntityType(types)) || defaultType;
};

export const normilizeIds = (data, idKey) =>
  data.map((item) => ({
    ...item,
    [idKey]: item[idKey]?.toString(),
  }));

export const quarterLabel = {
  separator: {
    CY: 'QCY',
    FY: 'QFY',
    default: 'Q',
  },
  normalize(qLabel, { isFiscalYear, yearDigits = 2, separator } = {}) {
    if (!qLabel) return null;

    let labelSeparator = qLabel.replace(/\d+/g, '');
    if (separator) labelSeparator = separator;
    else if (!isNil(isFiscalYear)) {
      labelSeparator = isFiscalYear ? this.separator.FY : this.separator.CY;
    }

    const [quarter, year] = qLabel.match(/\d+/g) || [];

    if (!quarter || !year) return null;
    const slicedYear = year.slice(-yearDigits);
    const decoratedYear = slicedYear.padStart(yearDigits, '20');

    return `${quarter}${labelSeparator}${decoratedYear}`;
  },
  getSeparator(qLabel) {
    return qLabel?.toString().replace(/\d+/g, '') || '';
  },
  convertToLastDay(qLabel) {
    if (!qLabel) return null;

    const [quarter, year] = qLabel.toString().match(/\d+/g) || [];
    if (!quarter || !year) return null;

    const month = (quarter * 3).toString().padStart(2, '0');

    return endOfMonth(`20${year.slice(-2)}-${month}-01`);
  },
};

export const getLastNDaysRange = (days, params) => {
  const endDate = params.maxDate || yesterday();

  const normalizedMaxPeriod = (() => {
    const maxPeriodByMinDate = params.minDate ? differenceInDays(endDate, params.minDate) : null;

    if (maxPeriodByMinDate) return Math.min(maxPeriodByMinDate, params.maxPeriod);
    return params.maxPeriod;
  })();

  const normalizedSubDays = normalizedMaxPeriod < days ? normalizedMaxPeriod : days;

  return {
    date_from: subDays(endDate, normalizedSubDays - 1), // startDate is inclusive
    date_to: endDate,
  };
};
